import React from 'react';

interface LoadingScreenProps {
  visible?: boolean;
  message?: string;
  subtext?: string;
}

export default function LoadingScreen({ visible = true, message = 'Loading', subtext }: LoadingScreenProps) {
  return (
    <div
      className="loading-screen"
      data-visible={visible}
      role="status"
      aria-live="polite"
      aria-label={message || 'Loading'}
    >
      <div className="loading-screen__inner">
        <div className="loading-screen__orb" aria-hidden="true" />
        {/* The mark carries a scheduled holiday's logo scene (docs/holiday-themes.md). The logo is a
            background so a dark theme draws (and fetches) only the dark-theme file. */}
        <span className="loading-screen__mark">
          <span className="loading-screen__logo" role="img" aria-label="ITA" />
        </span>
        <div className="loading-screen__bar" aria-hidden="true">
          <span className="loading-screen__bar-fill" />
        </div>
        <div className="loading-screen__text">
          <span className="loading-screen__message">{message}</span>
          {subtext && <span className="loading-screen__sub">{subtext}</span>}
        </div>
      </div>
    </div>
  );
}
